const e=async(e,t)=>{let{data:n}=await e.get(`/apps`,{params:t});return n};export{e as getApps};
//# sourceMappingURL=get-apps.mjs.map